import { Component, OnInit } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { CommonApiService } from "src/app/services/common-api-service";
import { EventService } from "src/app/services/event.service";
import { PopupService } from "src/app/services/popup.service";
import { API_Const } from "src/app/shared/constants/apiRouteConst";
import { CURRENCY, CURRENCY_SYMBOL, SPIN_WIN_PRIZES, convertNumToCurr, getEllipsis } from "src/app/shared/constants/app-enums";
import { ILootboxCard } from "../lootbox.interface";

@Component({
  selector: "app-spin-win",
  templateUrl: "./spin-win.component.html",
  styleUrls: ["./spin-win.component.scss"],
})
export class SpinWinComponent implements OnInit {
  title?: string;
  type!: SPIN_WIN_PRIZES;
  SPIN_WIN_PRIZES = SPIN_WIN_PRIZES;
  value!: number;
  showConfetti = true;
  showSellPrize = false;
  unit!: CURRENCY;
  CURRENCY = CURRENCY;
  CURRENCY_SYMBOL = CURRENCY_SYMBOL;
  prize!: ILootboxCard

  constructor(private modalService: BsModalService,
    private apiService: CommonApiService,
    private eventService: EventService,
    private popupService: PopupService,
  ) { }

  ngOnInit(): void {
    setInterval(() => (this.showConfetti = false), 1300);
  }

  keepNFT() {
    this.modalService.hide();
  }

  sellNFT() {
    this.eventService.showSpinner();
    this.apiService.post(API_Const.lootboxes.prizeCashout, {
      "prize_id": this.prize.prizeId
    }, true).subscribe({
      next: (res) => {
        this.eventService.hideSpinner();
        this.showSellPrize = true;
        this.modalService.hide();
      },
      error: (err) => {
        this.popupService.messsageAlert("error", err.error?.message ?? "Something went wrong!");
        this.eventService.hideSpinner();
        this.showSellPrize = false;
        this.modalService.hide();
      }
    });
  }

  convertNumToCurr(num: number) {
    return convertNumToCurr(num);
  }

  getEllipsis(text: string, max: number) {
    return getEllipsis(text, max);
  }

  claimPrize() {
    this.modalService.hide();
  }

  getBgUrl(url?: string): string {
    if (url) {
      return `url(${url})`
    }
    return '';
  }
}
